import { ConfigItemKey } from 'src/types';

import { getConfigItem } from './config';

export const isDataDogSynthetics = () =>
  typeof window !== 'undefined' && window._DATADOG_SYNTHETICS_BROWSER;

export const isCypressTest = (): boolean =>
  Boolean(getConfigItem(ConfigItemKey.IS_CYPRESS_TEST, undefined));

export const isAutomationTest = () => isCypressTest() || isDataDogSynthetics();
